<div class="modal-content p-3">
  <div class="modal-header">
    <h5 class="modal-title w-100 pe-2" id="myModalLabel">{{ userPersistenceService.generalTranslation.ChangeyourPwd }}</h5>
    <button type="button" class="btn-close modal-close" aria-label="Close" (click)="modalRef.hide()"></button>
  </div>

  <div class="modal-body">
    @if (passwordExpired && !userPasswordReset) {
      <div>
        <p class="alert alert-warning">{{ userPersistenceService.generalTranslation.PasswordExpiredMsg }}</p>
      </div>
    }
    <div class="forgotPasswordblock">
      <div class="row">
        <div class="col-md-12">
          <ifc-input-field name="oldPassword" type="password" [form]="form" [schema]="schema" maxlength="100"></ifc-input-field>
          <ifc-input-field name="newPassword" type="password" [form]="form" [schema]="schema" maxlength="40"></ifc-input-field>
          <ifc-input-field name="confirmPassword" type="password" [form]="form" [schema]="schema" maxlength="40"></ifc-input-field>
        </div>
      </div>
      <div class="row pt-md-3">
        <div class="col-md-12">
          <p>{{ userPersistenceService.generalTranslation.ChangePasswordHint }}</p>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer mt-3" >
    <div class="col-md-12 border-top text-end pt-4 pe-0 pb-0 ps-0 change-password-actions">
      <button type="button" mat-stroked-button color="primary" class="btn btn-cancel text-uppercase body2 mt-0 mb-0 pt-2 pb-2 no-shadow rounded btn-min-width"
        aria-label="Close" (click)="onCancelClick()">
        {{ userPersistenceService.generalTranslation.Cancel }}
      </button>
      <button type="button" mat-raised-button color="primary" class="relative btn btn-save text-uppercase body2 mt-0 mb-0 pt-2 pb-2 no-shadow rounded me-0 ms-2 btn-min-width me-0"
        (click)="onSaveClick()">
        {{ userPersistenceService.generalTranslation.Save }}
      </button>
    </div>
  </div>
</div>
